const en = require('./translations/en')

var I18n = I18n || {};
I18n.translations = {
  'en': en,
}

module.exports = I18n